import React, {Fragment} from 'react';
import "./Header.css";
import headerImage from '../../assets/food-tour.jpg'
import HeaderCartBtn from "./HeaderCartBtn";


function Header(props) {


    return (
        <Fragment>
            <header className="header">
                <h1>New York Eats</h1>
                <HeaderCartBtn onClick={props.onShowCart}/>
            </header>

            <div className="main-image">
                <img src={headerImage} alt="New York Food"/>
            </div>

        </Fragment>
        )
}

export default Header;